// AUTO-GENERATED - DO NOT EDIT MANUALLY
// Generated from App\Controller\Dto\Response\FeatureVoteResponse

import { DateTimefromISO } from '#lib/helper/date.js';
import type { DateTime } from 'luxon';

export type FeatureVoteApiResponse = {
	feature: string;
	vote: boolean | null;
	updatedAt: string;
};

export type FeatureVote = {
	feature: string;
	vote: boolean | null;
	updatedAt: DateTime;
};

export function hydrateFeatureVote(data: FeatureVoteApiResponse): FeatureVote {
	return {
		...data,
		updatedAt: DateTimefromISO(data.updatedAt)!,
	};
}